document.addEventListener("DOMContentLoaded", function () {
  const images = document.querySelectorAll("img.lazy-defer");
  if ("IntersectionObserver" in window) {
    const imgObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;

          if (img.dataset.src) img.src = img.dataset.src;
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;

          img.classList.remove("lazy-defer");
          observer.unobserve(img);
        }
      });
    });
    images.forEach(img => imgObserver.observe(img));
  } else {
    // Fallback anciens navigateurs
    images.forEach(img => {
      if (img.dataset.src) img.src = img.dataset.src;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
    });
  }
});